import { __awaiter, __generator } from "tslib";
import { compKey } from './key';
export var createResponsiveBreadcrumbsDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        exists: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.exists()];
        }); }); },
        allTextValues: function () { return base.$$('.breadcrumb-item .text').text(); },
        numOfItems: function () { return base.$$('.breadcrumb-item').count(); },
        numOfSeparators: function () { return base.$$('.breadcrumb-item .breadcrumb-separator').count(); },
        hasTooltip: function () { return base.$('.breadcrumb-desc-tooltip').exists(); },
        getLastBreadCrumbItem: function () { return base.$('.breadcrumb-item.last').text(); },
        isClickable: function (idx) { return base.$$('.breadcrumb-item').get(idx).hasClass('clickable'); },
        clickItem: function (idx) { return base.$$('.breadcrumb-item').get(idx).click(); },
        allItemsWithTypographyType: function (typographyType) {
            return base.$$(".breadcrumb-item .text").filter(function (text) { return text.hasClass(typographyType); });
        },
        base: base
    };
};
//# sourceMappingURL=driver.js.map